import { z } from "zod";
import { EntityType } from "./schemas/event.js";
import { SourceStatus } from "./enums.js";
/** Global server-sent stream (GET /api/events/stream): cheap invalidation hints. */
export const LiveEvent = z.discriminatedUnion("event", [
    z.object({
        event: z.literal("entity_changed"),
        type: EntityType,
        id: z.string().uuid(),
        project_id: z.string().uuid().nullable(),
        event_id: z.string().uuid().nullable(),
    }),
    z.object({
        event: z.literal("intake_processed"),
        source_id: z.string().uuid(),
        status: SourceStatus,
        project_id: z.string().uuid().nullable(),
        project_name: z.string().nullable(),
        summary: z.string().nullable(),
        event_id: z.string().uuid().nullable(),
        reason: z.string().nullable(),
        submitted_by: z.string().uuid().nullable(),
    }),
    z.object({ event: z.literal("inbox_count"), n: z.number().int() }),
    z.object({ event: z.literal("report_ready"), report_id: z.string().uuid(), headline: z.string() }),
]);
//# sourceMappingURL=liveEvents.js.map